import { useNavigate, useLocation } from "react-router-dom";
import { Home, Mail, PlusCircle, Settings } from "lucide-react";
import { useConnections } from "@/hooks/useConnections";

const tabs = [
  { path: "/",        icon: Home,       label: "Главная"   },
  { path: "/inbox",   icon: Mail,       label: "Входящие"  },
  { path: "/add",     icon: PlusCircle, label: "Добавить"  },
  { path: "/settings",icon: Settings,   label: "Настройки" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { pending } = useConnections();

  return (
    <nav className="bottom-nav glass" data-testid="bottom-nav">
      {tabs.map(({ path, icon: Icon, label }) => {
        const active = pathname === path || (path !== "/" && pathname.startsWith(path));
        const badge = path === "/inbox" && pending.length > 0 ? pending.length : 0;
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            data-testid={`nav-${label.toLowerCase()}`}
            className="flex flex-col items-center gap-1 px-5 py-2 rounded-2xl transition-all duration-200 relative"
            style={{ color: active ? "hsl(var(--primary))" : "hsl(var(--muted-foreground))" }}
          >
            {active && (
              <span
                className="absolute inset-0 rounded-2xl"
                style={{ background: "hsl(var(--primary)/0.1)" }}
              />
            )}
            <span className="relative">
              <Icon
                size={22}
                strokeWidth={active ? 2 : 1.5}
                style={{ transition: "all 0.2s" }}
              />
              {badge > 0 && (
                <span
                  className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full text-[9px] font-bold flex items-center justify-center"
                  style={{ background: "hsl(var(--critical-text))", color: "white" }}
                >
                  {badge}
                </span>
              )}
            </span>
            <span className="text-[10px] font-medium tracking-wide">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
